<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <Navigation />
    <!-- 个人简介 -->
    <div class="bg_box">
      <div class="noneBox"></div>
      <div class="box">
        <p class="back" @click="$router.back()">返回</p>
        <img src="../../assets/wordOp/AI.png" alt="" class="title">
        <div class="ct_box">
          <div class="form_box">
            <div class="switch_box flex">
              <div @click="select_versionShow('1')" :class="form.select_version == '1' ? 'sliderActive' : 'switchLt'">
                基础版
              </div>

              <div @click="select_versionShow('2')" :class="form.select_version == '2' ? 'sliderActive' : 'switchRt'">
                高级版
              </div>
              <div :class="form.select_version == '1' ? 'slider1' : 'slider2'"></div>
            </div>
            <div class="select_box flex">
              <p class="title_1">分辨率</p>
              <el-select v-model="form.resolving_power" placeholder="选择分辨率">
                <el-option v-for="(item, index) in resolving_power_List" :key="index" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="select_box flex" v-if="form.select_version == '1'">
              <p class="title_1">风格</p>
              <el-select v-model="form.style" placeholder="选择风格">
                <el-option v-for="(item, index) in styleList" :key="index" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="select_box flex">
              <p class="title_1">关键词</p>
              <el-input show-word-limit :maxlength="maxLength" class="keyWords" resize="none" type="textarea" :rows="3"
                placeholder="请描述生图内容，字数限制100字，仅支持中文、日常标点符号画面主体(画什么)+细节词(长什么样子)+风格词(是什么风格)" v-model="form.keyWords">
              </el-input>
            </div>
            <button class="submit" @click="FileData">生成内容</button>
            <div class="z-img" v-if="contentData == {}">
            </div>
            <img v-if="contentData != {}" class="z-img" :src="contentData.output_content" alt="">
            <button :href="contentData.output_content" class="copy" target="downloadFile" download="AI"
              @click="copy()">下载图片</button>
          </div>
          <wordNav />
          <aiNum title="计费规则：" :text="aiNumText" :visible="aiNumShow" @close="aiNumShow = false" @postData="postData" />
          <aiPoup :visible="aiPoupShow" @close="aiPoupShow = false" />
        </div>
      </div>
    </div>
    <footerBot />
  </div>
</template>

<script>
import wordNav from '../../components/wordNav.vue'

export default {
  name: '',
  created() { },
  mounted() { },
  components: {
    wordNav
  },
  data() {
    return {
      aiNumText: 'AI作图(基础版0.90元)',
      maxLength: 100,
      form: {
        select_version: '1',
        style: '',
        resolving_power: '',
        // resolving_width: '',// 分辨率宽度
        // resolving_height: '',// 分辨率高度
        keyWords: '', // 关键词
      },
      resolving_power_List: ['1024*1024', '1024*1536', '1536*1024'],
      styleList: ['探索无限', '古风', '二次元', '写实风格', '浮世绘', 'low poly', '未来主义', '像素风格', '概念艺术', '赛博朋克', '洛丽塔风格', '巴洛克风格', '超现实主义', '水彩画', '蒸汽波艺术', '油画', '卡通画'],
      contentData: {}, //内容
      fullscreenLoading: false,
      aiNumShow: false,
      aiPoupShow: false,
    }
  },
  methods: {
    select_versionShow(id) {
      if (this.form.select_version == id) {
        return
      }
      this.form.select_version = id
      if (this.form.select_version == '1') {
        this.aiNumText = 'AI作图(基础版0.90元)'
        this.maxLength = 100
        // this.resolving_power_List
        this.resolving_power_List = ['1024*1024', '1024*1536', '1536*1024']
      } else {
        this.aiNumText = 'AI作图(高级版3.00元)'
        this.maxLength = 200
        this.resolving_power_List = ['512*512', '640*360', '360*640', '1024*1024', '1280*720', '720*1280', '2048*2048', '2560*1440', '1440*2560']
      }
      console.log(this.form.select_version);

    },
    // 获取用户信息
    getUserInfo() {
      this.curlGet('/api/user/info').then((res) => {
        if (res.data.code) {
          this.$user_info = res.data.data
          this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
        }
      })
    },
    copy() {
      //参数是复制的内容
      //.then()中的函数是复制成功和复制失败的两个回调函数
      this.$copyText(this.contentData.output_content).then(
        (e) => {
          let a = document.createElement('a')
          a.style = 'display: none'
          a.target = "_blank"

          a.download = 'file' + new Date().valueOf()
          a.href = this.contentData.output_content
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          // return this.$message({
          //   message: '复制成功',
          //   type: 'success',
          //   offset: 80,
          // });
        },
        (err) => {
          return this.$message({
            message: '复制失败',
            type: 'warning',
            offset: 80,

          });
        }
      );
    },
    FileData() {
      if (!this.form.resolving_power) {
        return this.$message({
          message: '请选择分辨率',
          type: 'warning',
          offset: 80,
        });
      }
      if (this.form.select_version == '1' && !this.form.style) {
        return this.$message({
          message: '请填写类型',
          type: 'warning',
          offset: 80,
        });
      }
      if (!this.form.keyWords) {
        return this.$message({
          message: '请填写关键词',
          type: 'warning',
          offset: 80,
        });
      }
      if (this.$user_info.money <= 0) {
        this.aiPoupShow = true
      } else {
        this.aiNumShow = true

        // this.postData()
      }
    },
    postData() {
      this.aiNumShow = false
      this.fullscreenLoading = true
      let data = {}
      data.mobile = this.$user_info.mobile
      data.select_version = this.form.select_version
      if (this.form.select_version == '1') {
        // 辣鸡版生成-发送数据
        data.resolving_power = this.form.resolving_power
        data.style = this.form.style
        data.input_text_basis = this.form.keyWords
      } else {
        // 高鸡版生成-发送数据
        data.resolving_width = this.form.resolving_power.substring(0, this.form.resolving_power.indexOf('*'))
        data.resolving_height = this.form.resolving_power.substring(this.form.resolving_power.indexOf('*') + 1, this.form.resolving_power.length + 1)
        data.input_text_senior = this.form.keyWords
      }
      this.curlPost('/file/drawing_ai', data).then(res => {
        console.log(res);
        this.fullscreenLoading = false
        if (res.data.code) {
          if (res.data.data.output_content) {
            this.contentData = res.data.data
            this.form = {
              select_version: '1',
              style: '',
              resolving_power: '',
              keyWords: '',
            }
            this.$alert('生成成功!该图片链接1小时时限期,过时图片链接失效', '提示:', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });

            // 扣费
            this.curlPost('/api/users/money_log/spend', {
              ai_id: res.data.data.id,
              amount: res.data.data.money,
            }).then(res => {
              if (res.data.code) {
                this.getUserInfo()
              }
            })

          }
        } else {
          return this.$message({
            message: res.data.msg,
            type: 'warning',
            offset: 80,
          });
        }
      })
    }
  },
}
</script>

<style lang=scss scoped>
@import '../../scss/EnterpriseProfile'
</style>